"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: right;\n\n  .Logos__parts {\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  .Logos__parts + .Logos__parts {\n    padding-left: ", ";\n  }\n\n  .Logos__subtitle {\n    color: #000;\n    font-size: .5rem;\n    line-height: .5rem;\n  }\n"], ["\n  text-align: right;\n\n  .Logos__parts {\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  .Logos__parts + .Logos__parts {\n    padding-left: ", ";\n  }\n\n  .Logos__subtitle {\n    color: #000;\n    font-size: .5rem;\n    line-height: .5rem;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.space.s300;
});
var templateObject_1;
